import React from 'react';
import { Paper, Grid, Box } from '@material-ui/core';

import useAdditionalServices from './useAdditionalServices';
import { useStyles, Icon } from './styles';
import { Feature } from 'components/elements';

const BookingAdditionalServices = ({ boxPaddings }) => {
	const { filteredServices, servicesExist } = useAdditionalServices();
	const { grid } = useStyles();

	if (!servicesExist) return null;

	return (
		<Paper>
			<Box {...boxPaddings}>
				<Grid container justify="center" alignItems="flex-start">
					{filteredServices.map(({ id, src, selected, price, label }) => (
						<Grid key={id} item xs={2} className={grid}>
							<Feature
								selected={selected}
								price={price}
								name={label}
								icon={() => <Icon src={src} alt={label} />}
							/>
						</Grid>
					))}
				</Grid>
			</Box>
		</Paper>
	);
};

export default BookingAdditionalServices;
